import { player } from '@/app/entities/athlete/player'
import {
  BlueBoxTextType,
  PlayerStates,
  Tasks,
  TutorialEventType,
  TutorialObjectiveIds,
  type DisciplinePhaseManager
} from '../../types'
import {
  MobileDetector,
  playersManager,
  THREE,
  gsap,
  modes
} from '@powerplay/core-minigames'
import {
  drawConfig,
  pathsConfig
} from '@/app/config'
import {
  angleInfoState,
  gamePhaseState,
  mainState,
  textMessageTranslatableState,
  uiState
} from '@/stores'
import { trainingTasks } from '@/app/modes/training'
import { endManager } from '@/app/EndManager'
import { tutorialFlow } from '@/app/modes/tutorial/TutorialFlow'
import { tutorialObjectives } from '@/app/modes/tutorial/TutorialObjectives'

/**
 * Trieda pre vrhaciu fazu
 */
export class DrawPhaseManager implements DisciplinePhaseManager {

  private isActive = false

  /** callback na zavolanie po skonceni fazy */
  private callbackEnd: () => unknown

  /** ci natahujeme */
  public isDrawing = false

  /** ci uz skoncil draw a zacina hadzat */
  public isThrowing = false

  /** Posledna hodnota wind up - kvoli hlaske */
  private lastWindUpValue = 0

  /** Posledna hodnota uhla - kvoli hlaske */
  private lastAngleValue = 0

  /** frame counter */
  private drawingFrameCounter = 0

  /** rychlost na zaciatku natahnutia */
  private speedOnStartDrawing = 0

  /** offset inputsOverlay na desktope */
  private desktopOffset = { x: 0,
    y: 0 }


  /**
   * Pozicie na natahnutie
   */
  private drawStartPosition?: THREE.Vector2
  private drawEndPosition = new THREE.Vector2()

  /** ako velmi pohol hrac pri natahovani */
  public distanceBetweenPositions = 0

  /**
   * Konstruktor
   */
  public constructor(callbackEnd: () => unknown) {

    this.callbackEnd = callbackEnd

  }

  /**
   * Prepare
   */
  public preparePhase(): void {

    throw new Error('Method not implemented.')

  }

  /**
   * Start
   */
  public startPhase(): void {

    tutorialFlow.eventActionTrigger(TutorialEventType.drawStart)
    console.warn('Draw phase started')
    this.isActive = true
    gamePhaseState().$patch({
      showAngle: true,
      showBar: false,
      mark: -1,
      speedPower: 0,
      angle: 0,
      angleColor: ''
    })

  }

  /**
   * Update
   */
  public update(): void {

    if (this.isDrawing) {

      if (this.drawingFrameCounter === drawConfig.drawingFramesMax) {

        this.startThrow()

      } else {

        this.drawingFrameCounter += 1
        gamePhaseState().speedPower = 100 / drawConfig.drawingFramesMax * this.drawingFrameCounter

      }

    }

  }

  /**
   * Inputy pri behu
   */
  public handleInputs(): void {

    console.warn('Zaciname natahovat')

  }

  /**
   * Vrati poziciu kurzoru
   * @param e - event
   * @returns
   */
  private getXYfromEvent(e: MouseEvent | TouchEvent): { x: number, y: number } {

    let x = 0
    let y = 0
    if (window.TouchEvent && e instanceof TouchEvent) {

      if (e.touches[0]) {

        x = e.touches[0].clientX
        y = e.touches[0].clientY

      } else if (e.changedTouches[0]) {

        // na mobiloch mozu byt touches prazdne
        x = e.changedTouches[0].clientX
        y = e.changedTouches[0].clientY

      }

    } else {

      x = this.desktopOffset.x + e.pageX
      y = this.desktopOffset.y + e.pageY

    }
    return { x,
      y }

  }

  /**
   * Start draw
   * @param e - event
   */
  public startDraw(e: MouseEvent | TouchEvent, desktopOffset: {x: number, y: number}): void {

    if (!this.isActive || player.wasFoul || this.isThrowing) return

    this.desktopOffset = desktopOffset
    gamePhaseState().showBar = false
    const { x, y } = this.getXYfromEvent(e)
    uiState().$patch({
      showTrail: true,
      trailX: Math.round(x),
      trailY: Math.round(y)
    })

    player.setState(PlayerStates.draw)
    this.isDrawing = true
    console.log('star draw')
    this.drawStartPosition = new THREE.Vector2(x, y)
    this.drawEndPosition = new THREE.Vector2(x, y)

    if (MobileDetector.isMobile()) {

      document.addEventListener('touchmove', this.moveDraw.bind(this))

    } else {

      document.addEventListener('mousemove', this.moveDraw.bind(this))

    }

  }

  /**
   * Move draw
   * @param e - event
   */
  private moveDraw(e: MouseEvent | TouchEvent): void {

    if (!this.isDrawing) return
    const { x, y } = this.getXYfromEvent(e)
    console.log(x, y)
    if (x <= 10 || y <= 10) return
    this.drawEndPosition.set(x, y)
    this.setUpAngle()

    if (this.isDrawing) {

      uiState().$patch({
        trailX: Math.round(this.drawEndPosition?.x || 0),
        trailY: Math.round(this.drawEndPosition?.y || 0)
      })

    }

  }

  /**
   * End draw
   */
  public endDraw(): void {

    if (!this.isActive || !this.isDrawing) return

    if (this.isDrawing) {

      uiState().$patch({
        trailX: Math.round(this.drawEndPosition?.x || 0),
        trailY: Math.round(this.drawEndPosition?.y || 0)
      })

    }
    this.startThrow()

  }

  /**
   * start throw state
   */
  private startThrow(): void {

    if (!this.isDrawing) return
    if (MobileDetector.isMobile()) {

      document.removeEventListener('touchmove', this.moveDraw.bind(this), false)

    } else {

      document.removeEventListener('mousemove', this.moveDraw.bind(this), false)

    }
    this.isDrawing = false
    this.isThrowing = true
    console.log('end draw')

    player.setState(PlayerStates.throw)

  }

  /**
   * Zobrazenie hlasky o uspesnosti naprahu
   */
  public showMessageAngle(): void {

    const angle = this.lastAngleValue
    const text = this.getAngleColor(angle)

    angleInfoState().$patch({
      text: `${text}Angle`,
      value: Number(angle.toFixed(1)),
      visible: true
    })
    gamePhaseState().angleColor = text

    gsap.to({}, {
      onComplete: () => {

        angleInfoState().visible = false

      },
      duration: 1.5
    })

  }

  /**
   * Vrati farbu podla uhla
   * @param angle - uhol
   * @returns farbu podla uhla
   */
  private getAngleColor(angle: number): string {

    let text = 'perfect'
    if (angle <= 29) text = 'low'
    if (angle >= 41) text = 'steep'
    if ((angle > 29 && angle <= 32) || (angle >= 38 && angle < 41)) text = 'good'
    if ((angle > 32 && angle <= 34.5) || (angle >= 35.5 && angle < 38)) text = 'excellent'
    return text

  }

  /**
   * Zobrazenie hlasky o uspesnosti naprahu
   */
  public showMessageDraw(): void {

    const windUp = this.lastWindUpValue

    let text = 'weakDraw'
    let type = 4
    if (windUp >= 0.9) {

      text = 'goodDraw'
      type = 3

    }
    if (windUp >= 0.95) {

      text = 'excellentDraw'
      type = 2

    }
    if (windUp >= 1) {

      text = 'perfectDraw'
      type = 1

    }

    textMessageTranslatableState().$patch({
      show: true,
      text,
      type,
      top: 10
    })

  }

  /**
   * Vypocitanie uhla
   * @returns angle
   */
  private setUpAngle(): number {

    let angle = 25
    if (this.drawEndPosition && this.drawStartPosition) {

      // pocitanie uhla
      const vector = this.drawEndPosition.clone().sub(this.drawStartPosition).normalize() as THREE.Vector2
      angle = THREE.MathUtils.radToDeg(vector.angle()) % 90
      if (this.drawEndPosition.x > this.drawStartPosition.x) angle = 90 - angle
      if (this.drawEndPosition.y > this.drawStartPosition.y) angle = 0
      console.warn(
        'real angle:',
        angle
      )
      mainState().angle = angle
      angle = Math.max(25, angle)
      angle = Math.min(45, angle)
      this.distanceBetweenPositions = this.drawEndPosition.distanceTo(this.drawStartPosition)
      if (this.distanceBetweenPositions < 0.1) angle = 25
      gamePhaseState().angle = Math.round(angle)
      gamePhaseState().angleColor = this.getAngleColor(angle)

    }
    return angle

  }

  /**
   * Vypocet hodu
   */
  public calculateThrow(): void {

    if (this.distanceBetweenPositions <= 0.1) {

      tutorialFlow.eventActionTrigger(TutorialEventType.drawNoAngle)

    }
    if (player.wasFoul) {

      if (!this.isDrawing && !this.isThrowing) {

        tutorialFlow.eventActionTrigger(TutorialEventType.drawNoInput)

      }

    } else if (this.distanceBetweenPositions > 0.1) {

      tutorialFlow.eventActionTrigger(TutorialEventType.drawSuccess)

    }

    // wind up podla baru
    const windUpBar = 15 / drawConfig.drawingFramesMax * this.drawingFrameCounter

    let windUp = 0.8 + windUpBar / 65
    if (windUpBar > 13) windUp = 1 - (windUpBar - 13) / 20
    if (windUp >= 0.9) {

      tutorialObjectives.passObjective(TutorialObjectiveIds.windUp)

    }

    // power podla atributu
    const throwPower = this.getThrowPower()

    // nulovanie frame countera
    this.drawingFrameCounter = 0

    if (this.drawEndPosition && this.drawStartPosition) {

      const angle = this.setUpAngle()
      if (angle > 25 && angle < 45) {

        tutorialObjectives.passObjective(TutorialObjectiveIds.angle)

      }

      const anglePenalty = Math.abs(35 - angle)

      // dlzka hodu
      const throwLength = 101.53 *
        (player.speedOnStartDrawing / 8) *
        ((100 - anglePenalty) / 100) *
        windUp *
        (throwPower / 100)

      // predslap
      const underStep = player.athleteObject.position
        .distanceTo(player.worldEnvLinesManager.playerPath?.getPointAt(pathsConfig.positionFoul) || new THREE.Vector3())

      player.javelin.speed = 11.5 + throwLength / 5
      player.javelin.throw(throwLength, angle)
      player.throwFinalLength = Math.floor((throwLength - underStep) * 100) / 100

      const windUpQ = Math.round((windUp - 0.8) / 0.2 * 100)
      trainingTasks.saveTaskValue(Tasks.draw, windUpQ)
      const angleQ = Math.round(100 - Math.pow(Math.abs(angle - 35), 2))
      trainingTasks.saveTaskValue(Tasks.angle, angleQ)

      this.lastWindUpValue = windUp
      this.lastAngleValue = angle

      if (!modes.isTutorial()) {

        if (windUp >= 1) endManager.perfectWindUpCount += 1
        const text = this.getAngleColor(angle)
        if (text === 'perfect') endManager.perfectAngleCount += 1
        
      }

      console.warn(`ThrowLength: ${throwLength},
ThrowPower: ${throwPower},
Angle: ${angle},
AnglePenalty: ${anglePenalty},
Speed: ${player.speedManager.getActualSpeed()},
underStep: ${underStep}
finalThrowLength: ${throwLength - underStep}
windUp: ${windUp}
javelinSpeed: ${player.javelin.speed}`)
      this.finishPhase()

    }

  }

  /**
   * Vypocet throwPower
   * @returns throwPower
   */
  private getThrowPower(): number {

    const attribute = playersManager.getPlayer()?.attribute.total || 0

    let throwPower = 50 + (attribute * 0.14)
    if (attribute > 100) {

      throwPower = 60 + (attribute * 0.04)

    }
    if (attribute > 1000) {

      throwPower = 100 + ((attribute - 1000) * 0.01)

    }
    return throwPower

  }

  /**
   * Set finish phase tween
   */
  public setFinishPhaseTween(): void {

    throw new Error('Method not implemented.')

  }

  /**
   * Finish
   */
  public finishPhase(): void {

    uiState().blueBoxTextType = BlueBoxTextType.hidden
    uiState().showTrail = false
    gamePhaseState().showAngle = false
    gamePhaseState().angle = 0
    gamePhaseState().angleColor = ''
    this.isActive = false
    this.callbackEnd()

  }
  /**
   * reset fazy
   */
  public reset(): void {

    this.isActive = false
    this.isDrawing = false
    this.isThrowing = false
    this.drawingFrameCounter = 0
    this.drawStartPosition = undefined
    this.drawEndPosition = new THREE.Vector2()
    this.speedOnStartDrawing = 0
    this.distanceBetweenPositions = 0

  }

}
